import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import useStyles from './styles'

function ThumbnailCell({ imageUrl, onClick }) {
  const classes = useStyles()

  return (
    <img
      className={classnames(classes.thumbnail, {
        [classes.isClickable]: !!onClick
      })}
      src={imageUrl}
      alt="thumbnail"
      onClick={onClick}
      // hide image completely if it fails to load instead of showing broken image icon
      onError={i => (i.target.style.display = 'none')}
    />
  )
}

ThumbnailCell.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default React.memo(ThumbnailCell)
